interface EmbeddedApplePodcastProps {
    link: string
    height?: string
    width?: string
    theme?: 'light' | 'dark'
    allowFullscreen?: boolean
}

const EmbeddedApplePodcast: React.FC<EmbeddedApplePodcastProps> = ({
    link,
    height = '175px',
    width = '100%',
    theme = 'light',
}) => {
    // Ensure the link is a valid Apple Podcast URL
    if (!link.includes('podcasts.apple.com')) {
        return null
    }

    // Convert the link to an embed URL if it's not already
    const embedUrl = link.replace('podcasts.apple.com', 'embed.podcasts.apple.com')

    return (
        <iframe
            allow="autoplay *; encrypted-media *; fullscreen *"
            height={height}
            width={width}
            style={{
                maxWidth: '100%',
                overflow: 'hidden',
                borderRadius: '10px',
                border: 'none',
            }}
            sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
            src={`${embedUrl}?theme=${theme}`}
        />
    )
}

export default EmbeddedApplePodcast
